import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { setHotel } from "@/store/slicers/auth.slicer";
import { useEffect, useMemo } from "react";

const useHotel = () => {
  const { user, hotel } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();

  const hotels = useMemo(() => {
    if (!user) return [];
    return user.hotels || [];
  }, [user]);

  useEffect(() => {
    if (user && !hotel && hotels.length === 1) {
      dispatch(setHotel({ hotel: hotels[0] }));
    }
  }, [user, hotels, hotel]);

  return { hotels, hotel, hotelId: hotel?.id, setHotel: (hotel: any) => dispatch(setHotel({ hotel })) };
};

export default useHotel;
